import React from "react";
import { Box, Typography, Button, Card, CardContent, Grid } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import { useNavigate } from "react-router";

export default function Pledge() {
  const navigate = useNavigate();
  
  return (
    <>
      {/* Home section */}
      <Box
        className="pledgeSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        {/* Mini Header (Top-Left) */}
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Pledge section */}
      <Box 
        sx={{ 
          minHeight: '80vh',
          position: 'relative',
          py: { xs: 2, md: 2 },
          px: { xs: 1, md: 2 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${imgUrl.pledgeBack})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.2,
            zIndex: 0
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 0
          }
        }}
      >
        {/* Logo/Icon - Outside and before the pledge boxes */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: {md: 1 },
            width: '100%',
            position: 'relative',
            zIndex: 1
          }}
        >
          <Box
            component="img"
            src={imgUrl.peaceIconNew}
            alt="Peace Icon"
            sx={{
              width: { xs: 60, md: 80 },
              height: 'auto',
              opacity: 0.9,
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
            }}
          />
        </Box>

        {/* Diagonal Layout Container */}
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: '1400px',
            minHeight: { xs: 'auto', sm: 'auto', md: '480px' },
            mb: { xs: 4, sm: 5, md: 8 },
            px: { xs: 1, sm: 2, md: 0 },
            zIndex: 1
          }}
        >
          {/* Opening Pledge - Left */}
          <Box
            sx={{
              position: { xs: 'relative', md: 'absolute' },
              left: { xs: 0, md: 0 },
              top: { xs: 0, md: 0 },
              width: { xs: '100%', sm: '100%', md: '45%' },
              maxWidth: { xs: '100%', md: '500px' },
              textAlign: 'center',
              py: { sm: 4, md: 5 },
              px: { sm: 3, md: 4 },
              mb: { xs: 3, sm: 4, md: 0 }
            }}
          >
            {/* Opening Pledge Title */}
            <Typography
              variant="h1"
              sx={{
                fontWeight: 400,
                fontFamily: 'Nelco Front5',
                color: '#111827',
                mb: { xs: 3, sm: 3, md: 4 },
                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2.25rem' },
                letterSpacing: '-0.02em',
                lineHeight: 1.2
              }}
            >
              Opening Pledge
            </Typography>

            {/* Opening Pledge Text */}
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.35rem' },
                  lineHeight: { xs: 1.7, md: 1.9 },
                  color: '#374151',
                  mb: { xs: 1.5, md: 2 },
                  textAlign: 'center',
                  px: { xs: 1, sm: 2, md: 3 },
                  fontFamily: 'var(--primary-font)',
                  fontWeight: 400
                }}
              >
                I Am Peacekeeper. I commit myself to Truth, Gratitude, Forgiveness, Love, Humility, Giving & Patience and will spread them. Peace.
              </Typography>
            </Box>
          </Box>

          {/* Closing Pledge - Right and Down */}
          <Box
            sx={{
              position: { xs: 'relative', md: 'absolute' },
              right: { xs: 0, md: 0 },
              top: { xs: 0, sm: 0, md: '200px' },
              width: { xs: '100%', sm: '100%', md: '45%' },
              maxWidth: { xs: '100%', md: '500px' },
              textAlign: 'center',
              py: { sm: 4, md: 5 },
              px: { sm: 3, md: 4 },
              mt: { xs: 0, md: 0 },
              borderRadius: 4,
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                borderRadius: 4,
                pointerEvents: 'none',
                zIndex: 0
              }
            }}
          >
            {/* Closing Pledge Title */}
            <Typography
              variant="h1"
              sx={{
                fontWeight: 400,
                fontFamily: 'Nelco Front5',
                mb: { xs: 3, sm: 3, md: 4 },
                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2.25rem' },
                letterSpacing: '-0.02em',
                lineHeight: 1.2,
                textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                position: 'relative',
                zIndex: 1
              }}
            >
              Closing Pledge
            </Typography>

            {/* Closing Pledge Text */}
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative', zIndex: 1 }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.35rem' },
                  lineHeight: { xs: 1.7, md: 1.9 },
                  mb: { xs: 1.5, md: 2 },
                  textShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
                  fontFamily: 'var(--default-font)',
                  fontWeight: 400
                }}
              >
                We are one. We care for Global Justice, Love and Peace. Peace.
              </Typography>
            </Box>
          </Box>
        </Box>
        {/* Download Certificate Button */}
        <Box sx={{ textAlign: 'center', mt: { xs: 2, md: 2 }, position: 'relative', zIndex: 1 }}>
          <Typography variant="h2" sx={{mb: 2, fontFamily: 'Trebuchet MS !important', fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.15rem' }, fontWeight: 400}}>
            All Pledges are taken with right hand put on the heart.
          </Typography>
<Button
  variant="contained"
  onClick={() => navigate("/login")}
  sx={{
    width: { xs: '92%', sm: 'auto' },
    mx: 'auto',
    display: 'block',
    px: { xs: 4, md: 6 },
    py: { xs: 1.4, md: 2 },
    fontSize: { xs: '0.9rem', md: '1rem' },
    fontWeight: 600,
    fontFamily: 'var(--default-font)',
    textTransform: 'none',
    borderRadius: '50px',  
    border: '4px solid #d9d9d9',
    background: 'linear-gradient(180deg, #3b82f6 0%, #1e3a8a 100%)',
    boxShadow: '0 4px 16px rgba(37, 99, 235, 0.4), 0 2px 8px rgba(37, 99, 235, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(180deg, #2563eb 0%, #1e40af 100%)',
      transform: { md: 'translateY(-2px)' },
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  }}
>
  Login or Register
</Button>
        </Box>
      </Box>
    </>
  );
}
